<template>
  <div class="navigation-menu">
    <div class="navigation-menu__logo" @mouseup="clickLogo($event)">
      <v-btn class="navigation-menu__logo-btn" fab dark small color="white">
        <v-icon color="#555">mdi-bullseye-arrow</v-icon>
      </v-btn>
      <span class="navigation-menu__logo-label">
        <!--<div class="navigation-menu__sign">beta</div>-->
        <div class="navigation-menu__text">uday.club</div>
      </span>
    </div>
    <v-list dense class="navigation-menu__menu">
      <template
              v-for="(item, key) in items"
      >
        <v-list-item
                :key="key"
                link
                :to="item.to"
                class="navigation-menu__item"
                :class="{'v-list-item--active': item.active}"
                @click="clickItem(item)"
        >
          <v-list-item-action>
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t(item.text) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <div
                v-if="!!item.items"
                class="navigation-menu__sub-items"
                :style="{'height': item.active ? (40 * item.items.length) + 'px' : 0}"
        >
          <v-list-item
                  v-for="(subItem, subKey) in item.items"
                  :key="key + '' + subKey"
                  link
                  :to="subItem.to"
                  class="navigation-menu__item navigation-menu__item_sub"
          >
            <v-list-item-action>
              <v-icon color="white">{{ subItem.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t(subItem.text) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </template>
    </v-list>
    <div class="mt-2">
      <div class="navigation-menu__btn" @click="$emit('open-chat')">
        <div class="navigation-menu__btn-icon">
          <v-icon>mdi-chat</v-icon>
        </div>
        <div class="navigation-menu__btn-label">{{ $t('msg.chatWithCurator') }}</div>
        <div v-if="unreadMessages" class="navigation-menu__btn-info">
          <div class="navigation-menu__btn-counter">{{ unreadMessages }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      items: {type: Array, default: () => []}
    },
    computed: {
      unreadMessages() {
        return this.$store.state.chat.unreadMessages;
      }
    },
    methods: {
      clickLogo(e) {

        if (e.which === 1) {
            if (this.$route.name === 'diary') {
                this.$store.commit('setSelectedDay', new Date());
                this.$store.commit('contentReload');
            } else {
                this.$router.push({name: 'diary'})
            }
        } else if (e.which === 2) {
            window.open('/', '_blank').focus();
        }
      },
      clickItem(item) {
        if (item.clickFunc === undefined) return;
        item.clickFunc();
      }
    }
  }
</script>

<style lang="scss">
  @import 'src/assets/scss/vars';

  .navigation-menu {
    margin: 15px;

    .navigation-menu__sub-items {
      height: 0;
      overflow: hidden;
      transition: height 0.25s ease;
    }
    .navigation-menu__logo {
      color: #fff !important;
      font-size: 22px;
      display: flex;
      align-items: center;
      padding-bottom: 15px;
      border-bottom: 1px solid #64696c;
      text-decoration: none;

      .navigation-menu__logo-btn {
        width: 32px;
        height: 32px;
        margin-left: 15px;

        .v-icon {
          font-size: 30px;
        }
      }
      .navigation-menu__logo-label {
        margin-left: 10px;
        cursor: pointer;
        font-weight: 300;
        position: relative;
        user-select: none;
      }
      .navigation-menu__text {
        line-height: 18px;
      }
    }
    .navigation-menu__menu {
      margin-top: 10px;
    }
    .v-list-item__title {
      color: #fff;
      font-weight: normal !important;
      font-size: 12px !important;
    }
    .v-list-item__action {
      margin-right: 15px !important;
    }
    .navigation-menu__item {
      margin-top: 10px;
      border-radius: 4px;

      &:hover {
        background-color: #777777;
      }
      &.navigation-menu__item_sub {
        min-height: 30px;
        margin-left: 20px;
        margin-right: 20px;

        &.v-list-item--active {
          background-color: $colorPrimaryDark !important;

        }
        .v-list-item__action {
          min-width: 4px;
        }
      }
    }
    .v-list-item--active {
      background-color: $colorPrimary !important;
    }
    .navigation-menu__sign {
      line-height: 10px;
      font-size: 10px;
      text-align: right;
      position: absolute;
      top: -10px;
      right: 0;
    }
    .navigation-menu__btn {
      min-height: 40px;
      background-color: $colorSecondary;
      color: rgba(0, 0, 0, 0.87);;
      padding: 0 16px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      display: flex;
      align-items: center;
      user-select: none;

      &:hover {
        background-color: rgba(255, 229, 176, 0.85);
      }
    }
    .navigation-menu__btn-icon {
      width: 38px;
    }
    .navigation-menu__btn-label {
      padding: 5px;
      flex: 1;
    }
    .navigation-menu__btn-counter {
      min-width: 20px;
      min-height: 20px;
      background-color: rgb(255 0 0 / 60%);
      color: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>